import { ChakraText, EquipUITheme } from '@equip.health/ui';

import { getPreferredFullName } from '~/lib/util/patient.util';

const { paragraph } = EquipUITheme.typography;

const TOP_LEVEL_ID = 'group-class-attendee';

interface AttendeeProps {
  attendee: GroupClassEventAttendeeExtended;
}

const Attendee = ({ attendee }: AttendeeProps) => {
  const { isAttendee } = attendee;
  return (
    <ChakraText
      color={isAttendee ? 'neutral.primary' : 'neutral.secondary'}
      id={`${TOP_LEVEL_ID}__${attendee.externalId}`}
      textDecoration={isAttendee ? 'unset' : 'line-through'}
      {...paragraph}
    >
      {getPreferredFullName(
        attendee?.chosenName,
        attendee.firstName,
        attendee.lastName,
      )}
    </ChakraText>
  );
};

export default Attendee;
